import getSubscriptionMock from './getSubscription.mock';

const cancelSubscriptionMock = {
  status: true,
  subscriptionInfo: getSubscriptionMock.data.getSubscriptionInfoCanceled,
};

export default cancelSubscriptionMock;
